import firebase from 'firebase'
import store from '../../store/store';

import { saveUser, setUserAccountsExistsCreds, getUserToken, setAuthenticating } from "../../actions"

let googleProvider = new firebase.auth.GoogleAuthProvider()
let facebookProvider = new firebase.auth.FacebookAuthProvider()


const getRedirectResult = () => {
	store.dispatch(setAuthenticating(!store.getState().app.authed))
	return firebase.auth().getRedirectResult()
	.then((result) => {
		// console.log('Result');
		// console.log(result);
		Promise.resolve(result);
	})
	.catch(function(error) {
		store.dispatch(setAuthenticating(false))
		return Promise.reject(error)
		// ...
	});
	
}

// eslint-disable-next-line
const doRedirectSignin = (p) => {
	// console.log('Sign in with Redirect');
	let provider = p === 'Google' ? googleProvider : facebookProvider;
	firebase.auth().signInWithPopup(provider);
	// .then((result) => {
	// 	console.log('Result');
	// 	console.log(result);
	// 	//throw new Error({code: "Test"})
	// 	if (result.user) {
	// 		result.user.loggedIn = true;
	// 		store.dispatch(getUserToken())
	// 		.then(() => {
	// 			store.dispatch(saveUser(result.user))
	// 			return Promise.resolve(result);
	// 		})
	// 	}
	// }).catch((error) => {
	// 	if (error.code === 'auth/account-exists-with-different-credential') {
	// 		// user has signed in with another provider
	// 		store.dispatch(setUserAccountsExistsCreds(error.credential, p));
	// 		return Promise.reject(error)
	// 	}
	// 	return Promise.reject(error)
	// });
}
// eslint-disable-next-line
const doRedirectSigninLink = (p) => {
	const User = store.getState('User')
	let existingProvider = User.User.existingProviderName === 'Google' ? googleProvider : facebookProvider;

	firebase.auth().signInWithRedirect(existingProvider).then((result) => {
		result.user.link(User.User.pendingCred).then(() => {
			//  account successfully linked to the existing Firebase user.
			//this.props.router.push('/');
			return Promise.resolve()
		});
	});
}
// eslint-disable-next-line
const doRedirectGoogleSignin = () => {
	doRedirectSignin('Google');
}
// eslint-disable-next-line
const doRedirectFacebookSignin = () => {
	doRedirectSignin('Facebook');
}
// eslint-disable-next-line
const getProviderForProviderId = (providers) => {
	let provider = null;
	switch (providers[0]) {
		case 'google.com':
			provider = {
				provider: googleProvider,
				providerName: 'Google'
			}
			break;
		default:
			provider = {
				provider: facebookProvider,
				providerName: 'Facebook'
			}
	}
	return provider;
}

export { doRedirectSignin, doRedirectSigninLink, doRedirectFacebookSignin, doRedirectGoogleSignin, getRedirectResult };



// WEBPACK FOOTER //
// ./src/components/signin/auth.js